import {Button} from '@luminopia/react-toolbox/lib/button'
import Form, {ITheme as IFormTheme} from 'core/components/form/Form'
import TextField, {ITextFieldProps} from 'core/components/form/text-field'
import {createValidator, required} from 'core/validation'
import * as React from 'react'
import {Dispatch} from 'react-redux'
import {Field, FormProps, reduxForm} from 'redux-form'
import * as classNames from './LoginForm.css'

export interface IPasswordFormFields {
  password: string
}

interface ITheme extends IFormTheme {
  button?: string
}

type OnSubmitType = (data: IPasswordFormFields, dispatch: Dispatch<void>) => void
interface IOwnProps {
  // TODO: The redux-form type for decorated component props is missing onSubmit, so declare it here
  onSubmit: OnSubmitType
}

interface IProps extends FormProps<IPasswordFormFields, {}, {}> {
  theme?: ITheme
}

/**
 * Password-only login form intended for use with redux-form.
 */
class LoginFormPassword extends React.PureComponent<IProps, {}> {
  public render(): React.ReactElement<{}> {
    const { handleSubmit, pristine, submitting, error, theme = {} } = this.props
    const passwordProps: ITextFieldProps = {
      type: 'password',
      label: 'Password',
      placeholder: 'Password',
      onEnter: handleSubmit,
    }

    const formTheme: IFormTheme = {
      error: theme.error,
    }

    return (
      <Form onSubmit={handleSubmit} error={error} theme={formTheme}>
        <Field name='password' component={TextField} props={passwordProps}/>
        <Button
          className={classNames.button}
          icon='arrow_forward'
          disabled={pristine || submitting}
          raised primary
          onClick={handleSubmit}
        >
        </Button>
      </Form>
    )
  }
}

export default LoginFormPassword

/**
 * Component factory for creating login forms, intended for use with redux-form.
 *
 * @param formName key to where your form's state will be mounted under the redux-form reducer
 * @param onSubmit fn called when prop `handleSubmit` is fired
 */
export const loginFormPasswordFactory = (
  {
    formName,
    onSubmit,
  }: {
    formName: string,
    onSubmit: OnSubmitType,
  },
) => {
  const initialValues: IPasswordFormFields = {
    password: '',
  }

  const formDecorator = reduxForm<IPasswordFormFields, {}, {}>({
    form: formName,
    initialValues,
    onSubmit,
    validate: createValidator({
      password: [required],
    }),
  })

  return formDecorator(LoginFormPassword)
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/login/LoginFormPassword.tsx